import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { useBookingContext } from '@providers/booking'
import { getServiceTypeByName } from '@shared/service_types'
import { isEmpty } from 'components-ui/src/shared'
import { Hooks } from 'service-api'

export const useBookingConf = () => {
  const bookingCtx = useBookingContext()
  const { accountName: locationName = '' } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const standaloneGroom = bookingCtx.state.serviceTypeName === 'grooming'
  const st = getServiceTypeByName('grooming', bookingCtx.state.data.serviceTypes)
  const notHasInStayBookingConf = isEmpty(bookingCtx.state.data.inStayBookingConf)
  const needsInStayBookingConf = !standaloneGroom && notHasInStayBookingConf

  const bookingConf = Hooks.useClientLocationBookingConf(locationName, needsInStayBookingConf ? st?.id : undefined)

  if (standaloneGroom) {
    if (isLoading) {
      setIsLoading(false)
    }
  } else {
    if (isLoading && bookingConf.isSuccess && bookingConf.data.results.length > 0) {
      setTimeout(
        () =>
          bookingCtx.dispatch({
            type: 'SET_INSTAY_BOOKING_CONFIG',
            payload: bookingConf.data.results[0],
          }),
        0
      )
      setTimeout(() => setIsLoading(false), 0)
    }
  }

  return {
    isLoading: isLoading,
    isError: bookingConf.isError,
    bookingConf: bookingConf.data,
  }
}
